import {ID} from 'simpli-web-sdk'

export default class RastreamentoDistanciaResponse {
  idCarga: ID = 0
  distanciaParaDestinoEmMetros: number | null = null
  duracaoParaDestinoEmSegundos: number | null = null
}
